const raw = process.env.REACT_APP_API_URL;

/** Production default: same host as the public site, no API port in the URL. */
const PROD_FALLBACK = "https://i-clima.com/api";

/** Current page origin + /api (never uses :33333 in the browser). */
function sameOriginApiUrl() {
  if (typeof window === "undefined") {
    return PROD_FALLBACK;
  }
  return `${window.location.origin}/api`;
}

export const API_URL =
  raw === "__SAME_HOST__" || raw === "__CADDY__"
    ? sameOriginApiUrl()
    : raw || PROD_FALLBACK;

// Set REACT_APP_SHOW_BGN_PRICES=false to hide secondary BGN prices across the
// customer-facing app. Admin forms and tables keep both currencies visible.
const showBgnPrices = process.env.REACT_APP_SHOW_BGN_PRICES;
export const SHOW_BGN_PRICES =
  showBgnPrices !== "false" && showBgnPrices !== "0";
